module.exports = __webpack_public_path__ + "media/images/ui__textArrowUpLight--dark-9f2f306ab7a42d5368877e7de0710ce3.png";